<template lang="pug">
AppPopover(
  ref="AppPopover"
  v-tooltip="{ closeOnClick: true }"
  placement="top"
  hide-close
  lazy
  span-class="d-inline"
  popover-container-classes=""
  extra-popover-classes="member-popover"
  :hide-from-action="hideMemberPopover"
  data-tipclass="member-popover-tooltip"
  data-original-title="View profile summary"
)
  PopoverAvatarUserCard(
    :key="userId"
    :user-id="Number(userId)"
    :organization-id="Number(organizationId)"
    :tab="tab"
  )
  template(#trigger)
    slot(v-if="defaultSlotPresent")
    span(
      v-else-if="html"
      role="button"
      v-html="html"
    )
    HubAvatar(
      v-else
      :user-id="Number(userId)"
      role="button"
      :avatar-style="avatarStyle"
    )
</template>

<script>
import PopoverAvatarUserCard from '~/components/PopoverAvatarUserCard.vue';
import AppPopover from '~/components/AppPopover.vue';
import HubAvatar from '~/components/HubAvatar.vue';

export default {
  name: 'PopoverAvatar',
  components: {
    AppPopover,
    PopoverAvatarUserCard,
    HubAvatar,
  },
  props: {
    organizationId: {
      type: [String, Number],
      required: true,
    },
    userId: {
      type: [String, Number],
      required: true,
    },
    avatarStyle: {
      type: String,
      default: 'speck',
    },
    html: { type: String },
    hideMemberPopover: {
      type: Boolean,
      default: false,
    },
    spanClass: {
      type: String,
      required: false,
    },
    tab: {
      type: String,
      default: null,
    },
  },
  computed: {
    defaultSlotPresent() {
      return this.$slots && !!this.$slots.default;
    },
  },
};
</script>
